import type { IntlShape } from 'react-intl';

export type FormattedTotals = {
  totalInCurrency?: string;
  totalInCompanyCurrency?: string;
  invoicesCount?: number;
};

type TotalsValue = {
  total_in_currency?: string;
  total_in_company_currency?: string;
  documents_count?: number;
};

// Returns FormattedTotals (not string); amountCellRenderer reads it via params.valueFormatted.
// Cast to AG Grid's ValueFormatterFunc happens at the wiring point (useAgGridColumnTypes).
export const totalsValueFormatter = ({ value }: { value?: TotalsValue | null }): FormattedTotals => {
  if (!value) return {};

  const {
    total_in_currency: totalInCurrency,
    total_in_company_currency: totalInCompanyCurrency,
    documents_count: invoicesCount,
  } = value;

  return { totalInCurrency, totalInCompanyCurrency, invoicesCount };
};

export type SparklineTooltipParams = {
  context: { data: Record<string | number, TotalsValue | undefined> };
  xValue: string | number;
};

type TooltipRendererOptions = {
  formatMessage: IntlShape['formatMessage'];
  isPriorityErp: boolean;
};

export const tooltipRenderer = (
  params: SparklineTooltipParams,
  { formatMessage, isPriorityErp }: TooltipRendererOptions,
): string => {
  const {
    context: { data },
    xValue,
  } = params;
  const { totalInCompanyCurrency, invoicesCount, totalInCurrency } = totalsValueFormatter({
    value: data[xValue],
  });

  return `
          <div>
            <p><strong>${xValue.toString()}</strong></p>
            <p>${totalInCurrency}</p>
            <p>${totalInCompanyCurrency}</p>
            ${
              isPriorityErp
                ? ''
                : `<p>${formatMessage({ id: 'company.dashboard.vendorExpenses.invoicesCount', defaultMessage: `${invoicesCount} invoices` }, { value: invoicesCount })}</p>`
            }
          </div>
        `;
};
